import { BookingFormMode } from "PFApp/booking/components/booking_form";
import { DetailsPanelType } from "PFApp/booking/components/details_panel/details_panel.types";

type CalculateActiveBookingIndexState = {
  bookingFormPanel: {
    order: number;
    isOpen: boolean;
    mode?: BookingFormMode;
  };
  bookingPanel: {
    order: number;
    isOpen: boolean;
  };
  activeBookingIndexByType: Record<
    DetailsPanelType.Booking | DetailsPanelType.BookingForm,
    number | undefined
  >;
};

export const calculateActiveBookingIndexState = ({
  bookingFormPanel,
  bookingPanel,
  activeBookingIndexByType
}: CalculateActiveBookingIndexState) => {
  const { order: bookingFormPanelOrder, isOpen: isBookingFormOpen, mode: bookingFormMode } = bookingFormPanel;
  const { order: bookingPanelOrder, isOpen: isBookingPanelOpen } = bookingPanel;
  if (
    isBookingFormOpen &&
    bookingFormMode === BookingFormMode.EditAll &&
    isBookingPanelOpen &&
    activeBookingIndexByType[DetailsPanelType.Booking] !==
      activeBookingIndexByType[DetailsPanelType.BookingForm] &&
    Math.abs(bookingFormPanelOrder - bookingPanelOrder) === 1 // we assume both panels must be one after another to be connected
  ) {
    // if both panels are open, and they have different indices we unify them basing on the "older" panel
    // case: one of them was just open while the other was already there
    const newerPanelType =
      bookingFormPanelOrder < bookingPanelOrder ? DetailsPanelType.Booking : DetailsPanelType.BookingForm;
    const olderPanelType =
      newerPanelType === DetailsPanelType.Booking ? DetailsPanelType.BookingForm : DetailsPanelType.Booking;

    return {
      [newerPanelType]: activeBookingIndexByType[olderPanelType]
    };
  }

  // in case one of the panels is closed, we reset its active index
  const result = {};
  if (!isBookingPanelOpen && !!activeBookingIndexByType[DetailsPanelType.Booking]) {
    result[DetailsPanelType.Booking] = undefined;
  }
  if (!isBookingFormOpen && !!activeBookingIndexByType[DetailsPanelType.BookingForm]) {
    result[DetailsPanelType.BookingForm] = undefined;
  }

  return result;
};
